/**
 * Component Entry
 *
 */

import Breadcrumb from './Breadcrumb'
export default Breadcrumb
export * from './Breadcrumb'
